import {
    section,
    container,
    cardTitle,
    coloredShadow,
    mlAuto,
    dashed
} from "../../../material-kit-pro-react.jsx";

import tooltipsStyle from "../../../material-kit-pro-react/tooltipsStyle.jsx";

const styles = {
    container,
    ...tooltipsStyle,
    section: {
        ...section,
        padding: "70px 0px"
    },
    coloredShadow,
    cardDescription: {
        color: "#3C4858", // "#999",
        textAlign: "center",
        padding: "0px !important",
        margin: "0px !important"
    },
    mlAuto,
    priceContainer: {
        display: "inline-flex"
    },
    price: {
        fontSize: "18px",
        color: "#9a9a9a"
    },
    priceNumber: {
        fontWeight:"400"
    },
    priceOld: {
        fontSize: "16px",
        textDecoration: "line-through"
    },
    priceNew: {
        color: "#f44336"
    },
    stats: {
        color: "#999"
    },
    textCenter: {
        textAlign: "center"
    },
    noTopPadding: {
        paddingTop: "0px !important",
        paddingBottom: "0px !important",
        marginTop: "0px !important",
        marginBottom: "0px !important"
    },
    centerImg: {
        height: "192px",
        minHeight: "192px",
        padding: "auto"
    },
    bedsDescription: {
        marginTop: "5px"
    },
    shadowCard: {
        boxShadow: "1px 1px 1px gray"
    },
    divButtonMore: {
        margin: "auto"
    },
    cardTitle: {
        ...cardTitle,
        minHeight: "54px",
        height: "54px"
    },
    truncatedText: {
        minHeight: "88px !important",
        height: "88px"
    },
    centerImgTour: {
        height: "232px",
        minHeight: "232px",
        padding: "auto"
    },
    explanatoryNote: {
        margin: "10px 0px 25px",
        color: 'red'
    },



    dashed,
    vecRoomContainer: {
        padding: "0",
        margin: "0",
        border: "1px solid gray",
        "& div": {
            backgroundColor: "#fff",
            padding: "6px"
        }
    },
    vecRoomTitle: {
        ...cardTitle,
        minHeight: "20px",
        height: "20px"
    },
};

export default styles;



// WEBPACK FOOTER //
// ./src/assets/jss/material-kit-pro-react/views/ecommerceSections/latestOffersStyle.jsx